import log from 'common/Logger';
import Story from 'common/Story';
import bridge from 'common/bridge';
import {loadVue} from './new/load_vue';
import Utils from '../common/Utils';
import {RTFacebookPixel} from '../common/fbpixel';

export class BasePage {

  name
  auth_required

  constructor(name, auth_required = false) {
    this.name = name;
    this.auth_required = auth_required;
    this.data = bridge.page_data;

    this.#injectGoogleWarningToLoginPage()
  }

  load(should_load_nav = true) {
    log.info(`loading logic for page: ${this.name}`);
    this.reportPageView();
	if (should_load_nav) this.loadNavigationBar();
  }

  loadNavigationBar() {
    const appEl = document.querySelector('#app')
	if (appEl === null) {
      const navEl = document.createElement('div');
      navEl.id="navigationContainer";
      document.body.prepend(navEl);
      loadVue('#navigationContainer');
	}
  }

  reportPageView() {
    //internal
    const payload = {param1: this.name};
    const ref = Utils.getUrlParams()['ref']
    if (ref) payload['param2'] = ref
    Story.addStep('pv', payload)
    //facebook
    RTFacebookPixel.trackPageView()
  }

  #injectGoogleWarningToLoginPage() {
    // After unsuccefull validation user redirects to another same page
    // but with name 'home' instead 'login'
    const pagesToInject = ['login', 'doLogin']

    if (!pagesToInject.some(page => location.pathname.includes(page))) {
      return
    }

    (function($) {
      $(document).ready(() => {
        const $target = $('#or-divider')

        if ($target.length === 0) {
          return
        }

        const $warningBox = $(`
          <div id="googleWarning" class='errors warning'>
            <ul>
              <li>
                <span>
                  Exciting news! ReadTheory expands to new domains,
                  <br />
                  be sure to whitelist for access.
                  <a target="_blank" href="https://readtheory.org/teachers-lounge/readtheory-expands-new-domains-same-commitment-to-education/">
                    Learn more
                  </a>                
                  🚀
                </span>
              </li>
            </ul>
          </div>
        `)

        $warningBox.css({
          'background-color': '#FEEAA5',
          'border-color': "#FEEAA5",
          'color': '#000000',
          'margin': '20px 0',
        })

        $warningBox.insertAfter($target)
      })
    })(window.jQuery)
  }

}
